import type { SlotCallbackParamsInterface } from '@cpc/comment-sdk-types/src/sdk';
import { toRefs } from 'vue';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';
import { scriptOnReady } from '@cpc/lib-js-require';

import { PROD_AD_SDK_JS_LINK } from '../../constants';
import { useCommentScene } from '../useCommentScene';

let commentPosIds: Array<string> = [];
let commentOrederIds: Array<string> = [];
let adRefreshBatch = 0;

export const moduleCommentAdCallback = async (slotCallbackParamas: SlotCallbackParamsInterface) => {
  const {
    el, // 广告插槽 dom 节点
    index, // 当前广告插槽索引值，从0开始
    size, // 当前评论列表已加载数目(刷次*每刷条数)
    total, // 当前文章的评论总条数
    type, // 广告插槽（评论）类型 new, hot, top
    domId, // 广告插槽 dom id （选择器）
    loadCompleted, // 当前刷 广告插槽已全部加载完成，会根据type触发多次，eg: 进入页面 hot 最后一条触发一次，new 最后一条触发一次；第二刷： new 最后一条再次触发
  } = slotCallbackParamas;

  // 是否为oppo上划场景
  const isOppoUpwardStroke = window.BrowserNormal?.getAppHost?.() === 6 || false;

  const ad_comment = window.moduleAdConfig.ad_comment;

  /**
   * isShow：是否开启广告
   *  false：关闭广告
   *  true：开启广告
   * order：广告显示位置长度是否为零
   * posIds：广告位长度是否为零
  */
  if (!ad_comment.isShow && (ad_comment.order && ad_comment.order.length > 0) && (ad_comment.posIds && ad_comment.posIds.length > 0) || isOppoUpwardStroke) {
    return;
  }

  if (ad_comment.order && ad_comment.order.length > 0) {
    ad_comment.order.forEach((item) => {
      if (item === index) {
        commentPosIds.push(ad_comment.posIds[commentPosIds.length]);
        commentOrederIds.push(domId);
      }
    })
  }

  if (loadCompleted) {
    const posIds = Array.from(new Set([...commentPosIds]));
    const ids = Array.from(new Set([...commentOrederIds]));

    console.log('>>> posIds, id:', posIds, ids);

    if (!posIds.length || !ids.length) {
      return;
    }

    adRefreshBatch++;

    if (window.heyTapAdInvoke) {
      handleAdInvoke(posIds, ids, adRefreshBatch);
    } else {
      scriptOnReady({
        url: window.pageData?.adSdkUrl || PROD_AD_SDK_JS_LINK,
        namespace: 'heyTapAdInvoke',
        callback: () => {
          handleAdInvoke(posIds, ids, adRefreshBatch);
        },
      });
    }
  }
};

const handleAdInvoke = async (posIds: string[], ids: string[], adRefreshBatch: number) => {
  const { documentMeta } = toRefs(useGlobalState());

  const { infinityCommentScene, microCommentScene } = useCommentScene();

  const isVideoComment = !!(infinityCommentScene() || microCommentScene());
  window
    .heyTapAdInvoke({
      posIds, // 分配的广告位id
      id: ids, // 需要渲染广告的dom id
      pageId: `${documentMeta.value.source}_${documentMeta.value.docId}`, // 必填，页面id，用于区分页面
      docId: documentMeta.value.docId, // 必填，文章内容id
      source: documentMeta.value.dataSource, // 必填，文章分发算法来源
      docSource: documentMeta.value.source, // 必填，文章内容来源
      isCommentAd: true,
      isVideoComment,
      adRefreshBatch,
    })
    .then((res) => {
      console.log('>>> heyTapAdInvoke --> res:', res); // 处理渲染的回调
    })
    .catch((err) => {
      console.log('>>> heyTapAdInvoke --> err:', err);
    })
    .finally(() => {
      commentPosIds = [];
      commentOrederIds = [];
    });
}
